import { qsStringify } from '../../utils/index.js'

export function transformParams(parameters, parametersSerializer) {
    if (parameters instanceof URLSearchParams) {
        return parameters.toString()
    }
    if (parameters && typeof parameters === 'object') {
        return (parametersSerializer ?? qsStringify)(parameters)
    }
    return parameters
}

export function transformBody(body, requestType, parametersSerializer, headers) {
    if (!body) {
        return
    }

    if (
        body instanceof FormData ||
        body instanceof Blob ||
        body instanceof ArrayBuffer ||
        ArrayBuffer.isView(body) ||
        body instanceof ReadableStream ||
        body instanceof URLSearchParams
    ) {
        return body
    }

    if (requestType === 'urlencoded') {
        headers.append('content-type', 'application/x-www-form-urlencoded; charset=utf-8')
        return transformParams(body, parametersSerializer)
    }

    if (requestType === 'json' && typeof body === 'object') {
        headers.append('content-type', 'application/json; charset=utf-8')
        return JSON.stringify(body)
    }

    if (requestType === 'form-data' && typeof body === 'object') {
        const fd = new FormData()
        for (const name of Object.keys(body)) {
            fd.append(name, body[name])
        }
        return fd
    }

    return body
}
